import anime from 'animejs';
import Scene from '../classes/scene';
import SceneManager from '../classes/scene-manager';
import { ScrollDirection } from '../classes/scroll-manager';
import {setDownloadReportURLPage} from "../helpers";

export default class WalkTheTalk extends Scene {
	
	constructor(manager: SceneManager, targetContainer: string) {
		super(manager, targetContainer);
	}

	onEnteredView(dir: ScrollDirection) {
		super.onEnteredView(dir);
		setDownloadReportURLPage(9);
	}
	
	onExitedView(dir: ScrollDirection) {
		super.onExitedView(dir);
		setDownloadReportURLPage(false);
	}
	
	
}
